export default "__VITE_ASSET__DHdZBu1Q__"